import { GlobalErrorHandler } from "../../services/error.handler";

/**
 * Fatal application error that would redirect to
 * custom view when thrown.
 */
export class FatalError extends Error {

  constructor(message?: string) {
    super(message);
    GlobalErrorHandler.fatalError = message;
    GlobalErrorHandler.isFatalError = true;
    Object.setPrototypeOf(this, FatalError.prototype);
  }
}

/**
 * Fatal application error that would redirect to
 * custom view when thrown.
 */
export class NotFoundError extends Error {

  constructor(message?: string) {
    super(message);
    GlobalErrorHandler.fatalError = message;
    GlobalErrorHandler.isFatalError = true;
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}

/**
 * Fatal application error that would redirect to
 * custom view when thrown.
 */
export class BoardNotFoundError extends Error {

  constructor(message?: string) {
    super(message);
    GlobalErrorHandler.fatalError = message;
    GlobalErrorHandler.isFatalError = true;
    Object.setPrototypeOf(this, BoardNotFoundError.prototype);
  }
}

/**
 * Fatal application error that would redirect to
 * custom view when thrown.
 */
export class GroupForbiddenError extends Error {

  constructor(message?: string) {
    super(message);
    GlobalErrorHandler.fatalError = message;
    GlobalErrorHandler.isFatalError = true;
    Object.setPrototypeOf(this, GroupForbiddenError.prototype);
  }
}
